<template>
  <div>
    <div v-html="contractSummaryMarkup"></div>
  </div>
</template>

<script>
export default {
  name: 'ContractSummary',
  computed: {
    contractSummaryMarkup() {
      return this.$store.getters.contractSummaryMarkup;
    }
  },
  methods: {},
  created() {}
};
</script>

<style>
</style>
